import { Button } from '@/components/ui/button';
import { useLocales } from '@/locales';
import Image from '@/components/shared/image';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Languages, Check } from 'lucide-react';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const handleChangeLang = newLang => {
    onChangeLang(newLang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex items-center gap-2 h-9 px-3 border border-gray-200 rounded-full hover:bg-gray-100"
        >
          <div className="w-5 h-5 flex items-center justify-center overflow-hidden rounded-sm">
            <Image
              disabledEffect
              alt={currentLang.label}
              src={currentLang.icon}
              className="w-full h-full object-cover"
            />
          </div>
          <Languages className="h-4 w-4 text-[#1a5c7d]" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel className="text-xs text-muted-foreground">
          Select Language
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {allLangs.map(option => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleChangeLang(option.value)}
            className="cursor-pointer"
          >
            <div className="w-5 h-5 mr-2 flex items-center justify-center overflow-hidden rounded-sm">
              <Image
                disabledEffect
                alt={option.label}
                src={option.icon}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="flex-1">{option.label}</span>
            {option.value === currentLang.value && (
              <Check className="h-4 w-4 text-orange-500" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
